import { Link } from "react-router-dom";
import { useTheme } from "@/context/ThemeContext";
import logoDark from "@/assets/logo-dark.png";
import logoLight from "@/assets/logo-light.png";

export default function Logo({ className = "", size = "md", withGlow = true, variant, testId = "brand-logo" }) {
  const { theme } = useTheme();
  const sizes = {
    sm: "h-7",
    md: "h-9",
    lg: "h-11",
    xl: "h-14",
    xxl: "h-24",
  };
  const resolved = variant || (theme === "dark" ? "dark" : "light");
  const src = resolved === "dark" ? logoDark : logoLight;
  return (
    <Link to="/" data-testid={testId} className={`relative inline-flex items-center group ${className}`}>
      {withGlow && (
        <span
          aria-hidden
          className="absolute -inset-3 rounded-full bg-brand-gradient opacity-0 blur-2xl group-hover:opacity-40 transition-opacity duration-500"
        />
      )}
      <img
        src={src}
        alt="Rxn3D"
        className={`${sizes[size]} w-auto relative transition-transform duration-500 group-hover:-rotate-1`}
        draggable="false"
      />
    </Link>
  );
}
